var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"mt-0 mb-2 mb-sm-0 mr-n3 mr-sm-0 ml-4 ml-sm-0 no-input-details pa-0",attrs:{"inset":""},on:{"change":_vm.setBundleSelection},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }